import axios from 'axios';
import {
  InviteUserRequest,
  InviteUserResponse,
  PaginatedActivityLogResponse,
  PaginatedUsersResponse,
  UpdateUserRequest,
  UpdateUserStatusRequest,
  UserListItem,
} from '../interfaces/UserManagementInterface';

const BASE_URL = process.env.REACT_APP_BASE_URL;

interface GetUsersParams {
  search?: string;
  page?: number;
  size?: number;
}

const getUsers = async (accessToken: string, params: GetUsersParams = {}) => {
  return axios.get<PaginatedUsersResponse>(`${BASE_URL}/users`, {
    headers: { Authorization: `Bearer ${accessToken}` },
    params,
  });
};

const updateUserStatus = async (accessToken: string, userId: string, body: UpdateUserStatusRequest) => {
  return axios.patch<UserListItem>(`${BASE_URL}/users/${userId}/status`, body, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
};

const updateUser = async (accessToken: string, userId: string, body: UpdateUserRequest) => {
  return axios.patch<UserListItem>(`${BASE_URL}/users/${userId}`, body, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
};

const resendUserInvite = async (accessToken: string, userId: string) => {
  return axios.post(`${BASE_URL}/users/${userId}/resend-invite`, null, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
};

const resetUserPassword = async (accessToken: string, userId: string) => {
  return axios.post(`${BASE_URL}/users/${userId}/reset-password`, null, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
};

const resetUserMfa = async (accessToken: string, userId: string) => {
  return axios.post(`${BASE_URL}/users/${userId}/reset-mfa`, null, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
};

interface GetActivityLogParams {
  page?: number;
  size?: number;
  action?: string;
  target_user_id?: string;
}

const getUserActivityLog = async (accessToken: string, params: GetActivityLogParams = {}) => {
  return axios.get<PaginatedActivityLogResponse>(`${BASE_URL}/users/activity-log`, {
    headers: { Authorization: `Bearer ${accessToken}` },
    params,
  });
};

const inviteUser = async (accessToken: string, body: InviteUserRequest) => {
  return axios.post<InviteUserResponse>(`${BASE_URL}/users/invite`, body, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
};

export {
  getUsers,
  getUserActivityLog,
  updateUserStatus,
  updateUser,
  resendUserInvite,
  resetUserPassword,
  resetUserMfa,
  inviteUser,
};
